// KPICodeList.jsx
import React from "react";
import { KPICodeItem } from "./KPICodeItem";
import { EmptyState } from "./EmptyState";

export function KPICodeList({
  performanceRatingDefinitions,
  editingCodeId,
  errorState,
  onStartEdit,
  onSaveEdit,
  onCancelEdit,
  onRemoveCode,
  onCodeChange
}) {
  if (performanceRatingDefinitions.length === 0) {
    return <EmptyState />;
  }

  return (
    <div className="space-y-1">
      {performanceRatingDefinitions.map((code, index) => {
        const isEditing = editingCodeId === index;
        
        return (
          <KPICodeItem
            key={index}
            index={index}
            code={code}
            isEditing={isEditing}
            errorState={errorState}
            onStartEdit={onStartEdit}
            onSaveEdit={onSaveEdit}
            onCancelEdit={onCancelEdit}
            onRemoveCode={onRemoveCode}
            onCodeChange={onCodeChange}
          />
        );
      })}
    </div>
  );
}